
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tastings",
      function () {
        return require("private-next-pages/tastings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tastings"])
      });
    }
  